export interface SpecialTopic {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  movieIds: string[];
  reviewIds: string[];
}

export const specials: SpecialTopic[] = [
  {
    id: "sp-rainy-romance",
    title: "雨季特别策划：那些发生在雨天的爱情",
    subtitle: "当整座城市开始下雨，故事才真正开始",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20rainy%20evening%20city%20street%20with%20glowing%20warm%20lamps%20and%20lone%20umbrella%20figure%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20golden%20accents%2C%20cinematic%20wide%20composition%2C%20dreamy%20romantic%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=1200&height=700&seq=sp-rainy-01&orientation=landscape",
    intro:
      "雨是爱情片最偏爱的一种天气。它模糊了距离，也放大了沉默。这一次，我们挑选了几部把「雨」用到极致的爱情电影，聊聊潮湿的空气里，那些更容易说出口的心事。",
    movieIds: ["yu-zhong-lai-xin", "kafei-yu-yu", "chang-ye"],
    reviewIds: ["rv-yuzhong-01", "rv-kafei-01", "rv-changye-01"],
  },
  {
    id: "sp-waiting",
    title: "主题影评：关于「等待」的十种写法",
    subtitle: "等人，是爱情片里最漫长也最动人的动作",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20solitary%20figure%20waiting%20at%20an%20old%20railway%20platform%20at%20dusk%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20accents%2C%20cinematic%20wide%20composition%2C%20dreamy%20melancholic%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=1200&height=700&seq=sp-waiting-01&orientation=landscape",
    intro:
      "从一封迟到七年的信，到一轮照了十年的明月，再到一段跨越光年的信号——「等待」以各种形态出现在爱情片里。本篇专题带你拆解这份执念的浪漫与重量。",
    movieIds: ["yu-zhong-lai-xin", "ming-yue-zhao-gui-tu", "yinhe-jintou-de-ni"],
    reviewIds: ["rv-yuzhong-01", "rv-mingyue-01", "rv-yinhe-01"],
  },
  {
    id: "sp-youth",
    title: "青春回响：我们都在校园里暗恋过一个人",
    subtitle: "那些没说出口的喜欢，都藏在细节里",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20sunlit%20school%20classroom%20with%20warm%20afternoon%20light%20and%20empty%20desks%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20golden%20accents%2C%20cinematic%20wide%20composition%2C%20dreamy%20nostalgic%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=1200&height=700&seq=sp-youth-01&orientation=landscape",
    intro:
      "校园爱情片之所以经久不衰，是因为它精准地复刻了每个人都经历过的阶段：想说又不敢说，想靠近又怕被发现。让我们一起回到那个阳光很慢的下午。",
    movieIds: ["cheng-nan-hua-kai", "hai-na-bian", "qiuri-siyu"],
    reviewIds: ["rv-chengnan-01", "rv-haibian-01", "rv-qiuri-01"],
  },
  {
    id: "sp-fantasy",
    title: "假如时间可以重来：奇幻爱情专题",
    subtitle: "当爱情遇上时空，所有的错过都有了另一种可能",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20glowing%20vintage%20clock%20floating%20in%20a%20starry%20sky%20above%20a%20quiet%20town%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20accents%2C%20cinematic%20wide%20composition%2C%20dreamy%20mysterious%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=1200&height=700&seq=sp-fantasy-01&orientation=landscape",
    intro:
      "奇幻爱情最迷人的地方，在于它给了「遗憾」一个被修改的机会。可当时间真的可以倒回，我们想要的，到底是改变结局，还是再见那个人一面？",
    movieIds: ["dongri-huaibiao", "shiguang-lvren", "yinhe-jintou-de-ni"],
    reviewIds: ["rv-shiguang-01", "rv-yinhe-01"],
  },
];